import { X, Loader2 } from 'lucide-react';
export interface RfqForm { type: string; description: string; quantity: string; unit: string; targetRate: string; salesOrderId: string; assignedTo: string }
interface Props { showModal:boolean;setShowModal:(v:boolean)=>void;form:RfqForm;setForm:(v:RfqForm)=>void;salesOrders:Array<{id:string;number:string}>;saving:boolean;handleCreate:()=>void }
export function QuotationJobForm({showModal, setShowModal, form, setForm, salesOrders, saving, handleCreate}:Props) { return <>
      {/* Create Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => setShowModal(false)}>
          <div
            className="mx-4 w-full max-w-lg rounded-xl border shadow-xl max-h-[90vh] overflow-y-auto"
            style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b px-6 py-4 sticky top-0 z-10 rounded-t-xl" style={{ borderColor: 'var(--border-primary)', backgroundColor: 'var(--bg-surface)' }}>
              <h2 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>New Quotation Job</h2>
              <button onClick={() => setShowModal(false)} style={{ color: 'var(--text-muted)' }} className="hover:opacity-70">
                <X size={20} />
              </button>
            </div>
            <div className="space-y-4 px-6 py-4">
              <div>
                <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Type *</label>
                <select
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                  className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                  style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                >
                  <option value="material">Material</option>
                  <option value="transport">Transport</option>
                </select>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Description *</label>
                <textarea
                  rows={3}
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  placeholder="Describe what needs to be procured..."
                  className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                  style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Quantity *</label>
                  <input
                    type="number"
                    value={form.quantity}
                    onChange={(e) => setForm({ ...form, quantity: e.target.value })}
                    placeholder="0"
                    className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                    style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                  />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Unit</label>
                  <input
                    type="text"
                    value={form.unit}
                    onChange={(e) => setForm({ ...form, unit: e.target.value })}
                    placeholder="e.g. kg, pcs, litres"
                    className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                    style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Target Rate (INR)</label>
                  <input
                    type="number"
                    value={form.targetRate}
                    onChange={(e) => setForm({ ...form, targetRate: e.target.value })}
                    placeholder="0"
                    className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                    style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                  />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Assigned To</label>
                  <input
                    type="text"
                    value={form.assignedTo}
                    onChange={(e) => setForm({ ...form, assignedTo: e.target.value })}
                    placeholder="Person name"
                    className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                    style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                  />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium" style={{ color: 'var(--text-primary)' }}>Linked Sales Order</label>
                <select
                  value={form.salesOrderId}
                  onChange={(e) => setForm({ ...form, salesOrderId: e.target.value })}
                  className="w-full rounded-lg border px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                  style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
                >
                  <option value="">None (standalone job)</option>
                  {salesOrders.map((so: any) => (
                    <option key={so.id} value={so.id}>{so.number} — {so.contact?.firstName || so.account?.name || 'Unknown'}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 border-t px-6 py-4" style={{ borderColor: 'var(--border-primary)' }}>
              <button
                onClick={() => setShowModal(false)}
                className="rounded-lg border px-4 py-2 text-sm font-medium transition-colors"
                style={{ borderColor: 'var(--border-primary)', color: 'var(--text-primary)' }}
              >
                Cancel
              </button>
              <button
                onClick={handleCreate}
                disabled={saving || !form.description || !form.quantity}
                className="flex items-center gap-2 rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] disabled:opacity-50"
              >
                {saving && <Loader2 size={14} className="animate-spin" />}
                Create Job
              </button>
            </div>
          </div>
        </div>
      )}
</>; }
